import { signOut } from "firebase/auth";
import { FcLock } from "react-icons/fc";
import { authFB } from "../firebase";

export const getStatusIcon = (id) => {
    const idStatus = Number(id);
    if (idStatus === 2) {
      return "🔒"; // Candado
    } else if (idStatus === 3) {
      return "✅"; // Check verde
    }
    return null; // No icono
  };

  export const getStatusNameIcon = (id) => {
    const idStatus = Number(id);
    if (idStatus === 1) {
        return "Disponible";
      } else
    if (idStatus === 2) {
      return "🔒 Reservado"; // Candado
    } else if (idStatus === 3) {
      return "✅ Vendido"; // Check verde
    }
    return ""; // No icono
  };

export const formatedDate = (date) => {
    const fecha = new Date(date+"T00:00:00");
const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

// Convierte la fecha a español con el formato deseado
const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones) ;

// Capitaliza la primera letra
const resultado = fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
return resultado
  }

  export const handleLogout = async () => {
    try {
      await signOut(authFB);
      // Redirigir o realizar acciones después de cerrar sesión
      console.log("User signed out");
      // Redirigir a la página de inicio o login
      window.location.href = "/"; 
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  export const getTicketClass = (status) => {
    switch (status) {
      case 1:
        return "available"; // Clase para los disponibles
      case 2:
        return "reserved";  // Clase para los reservados
      case 3:
        return "sold";      // Clase para los vendidos
      default:
        return "";          // Clase por defecto
    }
  };


  export const convertImageToBase64 = async (imageUrl, id) => {
    try {
      const response = await fetch(imageUrl, { mode: 'no-cors' });
      console.log("response", response);
      
      const blob = await response.blob();
      const reader = new FileReader();
      console.log("reader", reader);
  
      reader.onloadend = () => {
        const base64String = reader.result;
        localStorage.setItem(`portada-raffle-${id}`, base64String); // Guardar en localStorage
      };
  
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error al convertir la imagen a base64:", error);
    }
  };
  